// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-50b85e31\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../vux-loader/src/style-loader.js!../../../../vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../../vue-style-loader/lib/addStylesClient.js")("071b9cce", content, true);


//////////////////
// WEBPACK FOOTER
// ./~/vue-style-loader!./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-50b85e31","scoped":false,"hasInlineConfig":false}!./~/vux-loader/src/style-loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./~/vux/src/components/divider/index.vue
// module id = 357
// module chunks = 1